// extracted by mini-css-extract-plugin
export var CheckMarkIcon = "index-module--CheckMarkIcon--e2297";
export var Error = "index-module--Error--caec0";
export var PromoCodeInput = "index-module--PromoCodeInput--b19ab";
export var PromotionCodeChosen = "index-module--PromotionCodeChosen--7f4bf";
export var TrashIcon = "index-module--TrashIcon--66abe";